module.exports = __webpack_public_path__ + "static/media/24.be869b1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/400/24.png
// module id = 426
// module chunks = 0